// extracted by mini-css-extract-plugin
module.exports = {"default":"Modal_default__gG9hY","lg":"Modal_lg__KbuED","xl":"Modal_xl__ekCk0","full":"Modal_full__y7JGj"};